<template>
  <div class="language-box">
    <Popover
      :width="220"
      placement="bottom"
      trigger="click"
    >
      <template #reference>
        <div class="trigger-wrapper">
          <!-- <img :src="countryData[0]?.countryUrl" alt=""> -->
          <Icon
            style="font-size: 24px;"
            name="icon-language-glabal-l"
          />
          {{ language.current?.toUpperCase() }}
          <Icon name="arrow-down-l-2" />
        </div>
      </template>
      <template #default="{ hide }">
        <Country @saved="hide" />
      </template>
    </Popover>
  </div>
</template>

<script setup>
import Popover from '@/components/Popover/index.vue'
import Country from '../Country/index.vue'
import { useLanguageStore } from '@/pinia/language'
import { Icon } from '@/components/Icon'

const language = useLanguageStore()
</script>

<style lang="less" scoped>
.language-box {
  position: absolute;
  top: 0;
  left: 0;
}
.trigger-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 62px;
  height: 40px;
  margin-left: 12px;
  cursor: pointer;
  color: #052785;
  font-family: mon-600;
  font-size: 12px;
  img {
    width: 20px;
    object-fit: contain;
    margin-right: 2px;
  }
}

.dropdown-content-item-list {
  padding: 16px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  color: #6e717a;
  font-size: 12px;
  height: 220px;

  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: mon-500;
    padding: 8px;
    margin-top: 4px;
    margin-bottom: 4px;
    cursor: pointer;
    position: relative;
    &:hover {
      border-radius: 4px;
      background: #f5f5f5;
      color: #232323;
    }
    &.selected {
      border-radius: 4px;
      background: #f5f5f5;
      color: #232323;
    }
  }
}
</style>
